import InfoLink from "./InfoLink";

export default InfoLink;
